import { path } from 'ramda';
export const getLanguage = path(['language', 'language']);
